import Vue from 'vue';
import App from './App.vue';
import VueCoreVideoPlayer from 'vue-core-video-player';
import vuetify from './plugins/vuetify';
import VueTimers from 'vue-timers';

Vue.config.productionTip = false;
Vue.use(VueCoreVideoPlayer);
Vue.use(VueTimers);

import store from './store';
new Vue({
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#app');
